// Country list (ISO 3166 alpha-2) — most popular for European tourism
export const COUNTRIES = [
  { code: "IT", it: "Italia", en: "Italy", de: "Italien", fr: "Italie" },
  { code: "DE", it: "Germania", en: "Germany", de: "Deutschland", fr: "Allemagne" },
  { code: "FR", it: "Francia", en: "France", de: "Frankreich", fr: "France" },
  { code: "GB", it: "Regno Unito", en: "United Kingdom", de: "Vereinigtes Königreich", fr: "Royaume-Uni" },
  { code: "US", it: "Stati Uniti", en: "United States", de: "USA", fr: "États-Unis" },
  { code: "ES", it: "Spagna", en: "Spain", de: "Spanien", fr: "Espagne" },
  { code: "CH", it: "Svizzera", en: "Switzerland", de: "Schweiz", fr: "Suisse" },
  { code: "AT", it: "Austria", en: "Austria", de: "Österreich", fr: "Autriche" },
  { code: "NL", it: "Paesi Bassi", en: "Netherlands", de: "Niederlande", fr: "Pays-Bas" },
  { code: "BE", it: "Belgio", en: "Belgium", de: "Belgien", fr: "Belgique" },
  { code: "PT", it: "Portogallo", en: "Portugal", de: "Portugal", fr: "Portugal" },
  { code: "PL", it: "Polonia", en: "Poland", de: "Polen", fr: "Pologne" },
  { code: "SE", it: "Svezia", en: "Sweden", de: "Schweden", fr: "Suède" },
  { code: "NO", it: "Norvegia", en: "Norway", de: "Norwegen", fr: "Norvège" },
  { code: "DK", it: "Danimarca", en: "Denmark", de: "Dänemark", fr: "Danemark" },
  { code: "FI", it: "Finlandia", en: "Finland", de: "Finnland", fr: "Finlande" },
  { code: "IE", it: "Irlanda", en: "Ireland", de: "Irland", fr: "Irlande" },
  { code: "GR", it: "Grecia", en: "Greece", de: "Griechenland", fr: "Grèce" },
  { code: "CZ", it: "Repubblica Ceca", en: "Czech Republic", de: "Tschechien", fr: "République tchèque" },
  { code: "RO", it: "Romania", en: "Romania", de: "Rumänien", fr: "Roumanie" },
  { code: "HU", it: "Ungheria", en: "Hungary", de: "Ungarn", fr: "Hongrie" },
  { code: "CA", it: "Canada", en: "Canada", de: "Kanada", fr: "Canada" },
  { code: "AU", it: "Australia", en: "Australia", de: "Australien", fr: "Australie" },
  { code: "JP", it: "Giappone", en: "Japan", de: "Japan", fr: "Japon" },
  { code: "BR", it: "Brasile", en: "Brazil", de: "Brasilien", fr: "Brésil" },
  { code: "AR", it: "Argentina", en: "Argentina", de: "Argentinien", fr: "Argentine" },
  { code: "MX", it: "Messico", en: "Mexico", de: "Mexiko", fr: "Mexique" },
  { code: "CN", it: "Cina", en: "China", de: "China", fr: "Chine" },
  { code: "IN", it: "India", en: "India", de: "Indien", fr: "Inde" },
  { code: "RU", it: "Russia", en: "Russia", de: "Russland", fr: "Russie" },
  { code: "OTHER", it: "Altro", en: "Other", de: "Andere", fr: "Autre" },
];
